import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ChevronRight from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ListItem from "@material-ui/core/ListItem";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import IconButton from "@material-ui/core/IconButton";

import firebase from "firebase";

import db, { storage } from "../../../../firebase/firebase";
import Character from "./Character/Character";
import { selectUser } from "../../../../store/reducers/userSlice";
import {
  setCharacter,
  setActiveCharacter,
} from "../../../../store/reducers/characterSlice";
import classes from "./Characters.module.css";
import FormDialog from "../../../../hooks/Dialogs/FormDialog";

function Characters() {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const history = useHistory();
  const [characters, setCharacters] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [open, setOpen] = useState(false);
  const [charName, setCharName] = useState("");
  const confirmOpen = open;

  const handleInputChange = (e) => {
    setCharName(e.target.value);
  };
  const toggleModal = () => {
    setOpen(!open);
  };

  useEffect(() => {
    let unsubscribe = db
      .collection("users")
      .doc(user.uid)
      .collection("characters")
      .onSnapshot((snapshot) =>
        setCharacters(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            character: doc.data(),
          }))
        )
      );
    return () => {
      unsubscribe();
    };
  }, [user.uid]);

  const handleAddCharacter = () => {
    let newCharacter = null;
    let storageRef = storage.ref();
    let imagesRef = storageRef.child("/resources/images/avatars/Ms_Who.png");
    let macroRef = storageRef.child("/resources/images/macros/42.png");
    let bannerRef = storageRef.child("/resources/images/banners/golden.png");
    const showDialog = FormDialog(open);
    // let newCharName = charName;

    newCharacter = {
      characterName: charName,
      critEmote: "A mighty blow!",
      critFailEmote: "No...It cannot be!?!?!",
      macro1: "Avast!",
      macro2: "#d20+3",
      macro3: "take that! #4d6+2",
    };

    if (showDialog) {

      imagesRef.getDownloadURL().then((url) => {
        bannerRef.getDownloadURL().then((bannerUrl) => {
          macroRef.getDownloadURL().then((macroUrl) => {
            newCharacter["macro1Icon"] = macroUrl;
            newCharacter["macro2Icon"] = macroUrl;
            newCharacter["macro3Icon"] = macroUrl;
            newCharacter["characterPortrait"] = url;
            newCharacter["characterBanner"] = bannerUrl;

            const timestamp = firebase.firestore.FieldValue.serverTimestamp();
            db.collection("users")
              .doc(user.uid)
              .collection("characters")
              .add({
                timestamp: timestamp,
                uid: user.uid,
                character: newCharacter,
              })
              .then(function (docRef) {
                //console.log("Document written with ID: ", docRef.id);
                dispatch(setActiveCharacter(docRef.id));
                db.collection("users").doc(user.uid).set({
                  avatar: newCharacter.characterName,
                  portrait: newCharacter.characterPortrait,
                  banner: newCharacter.characterBanner,
                  id: docRef.id,
                });
              });
            dispatch(
              setCharacter({
                timestamp: timestamp,
                uid: user.uid,
                character: newCharacter,
              })
            );
            history.push("/profile");
          });
        });
      });
    }
  };

  function toggleCollapse() {
    setCollapsed((prevValue) => !prevValue);
  }

  function onClick(e) {
    toggleCollapse();
  }

  let expandIcon;

  if (!collapsed) {
    expandIcon = (
      <ExpandMoreIcon className={classes.sidebar__item__expand__arrow} />
    );
  } else {
    expandIcon = (
      <ChevronRight className={classes.sidebar__item__expand__arrow} />
    );
  }

  return (
    <>
      <ListItem
        className={classes.sidebar__item}
        onClick={onClick}
        button
        dense
      >
        <div className={classes.sidebar__item__content}>
          <h3 className={classes.sidebar__item__text}>Characters</h3>
        </div>
        {expandIcon}
      </ListItem>
      <Collapse in={!collapsed} timeout="auto" unmountOnExit>
        <List>
          {characters.map(({ id, character }) => (
            <React.Fragment key={`${id}`}>
              <Character
                key={id}
                id={id}
                character={character}
                active={characters.activeCharacter}
              />
            </React.Fragment>
          ))}
          {/* <Divider style={{ margin: "10px 0" }} /> */}
          <div className={classes.sidebar__channelsHeader}>
            <IconButton
              size="medium"
              className={classes.sidebar__button}
              onClick={() => toggleModal()}
            >
              <FormDialog
                title="Add new character?"
                open={confirmOpen}
                // toggleModal={toggleModal}
                onConfirm={handleAddCharacter}
                //trying to store value in state
                onChange={handleInputChange}
              ></FormDialog>
              <PersonAddIcon color="primary" />
            </IconButton>
            <h4 onClick={() => toggleModal()} className={classes.textHover}>
              New Character
            </h4>
          </div>
        </List>
      </Collapse>
    </>
  );
}

export default Characters;
